import { useQueryClient, useSuspenseQuery } from "@tanstack/react-query";
import { AuthError, signOut } from "aws-amplify/auth";
import { useCallback } from "react";

import { authQueryOptions } from "./authQuery";
import { applyTheme } from "./userPreferences";

export const isAuthUnauthenticatedError = (error: unknown): error is AuthError =>
  error instanceof AuthError && error.name === "UserUnAuthenticatedException";

export const useAuth = () => {
  const { data } = useSuspenseQuery(authQueryOptions);
  const signOutFn = useSignOut();

  if (data == null) {
    throw new Error("Auth data is missing after suspense.");
  }

  const { user, cognitoGroups, clientIds, branchIds, displayName, email, picture } = data;

  return {
    user,
    displayName,
    email,
    picture,
    cognitoGroups,
    clientIds,
    branchIds,
    signOut: signOutFn,
  };
};

const useSignOut = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    try {
      await signOut({
        global: true,
        oauth: { redirectUrl: import.meta.env.VITE_APP_URL },
      });
    } finally {
      applyTheme();
      queryClient.clear();
    }
  }, [queryClient]);
};
